export const pathBuilder = (path: string) => {
  return {
    withId: (id?: string) => pathBuilder(path.replace(':id', id ?? '')),
    withNotificationType: (notificationType?: string) =>
      pathBuilder(path.replace(':notificationType', notificationType ?? '')),

    build: () => path.replaceAll('//', '/').replace(/\/$/g, ''),
  }
}
